'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
require('../components/Layout/LoginLayout.scss.js');
var Header = require('../components/Header.js');
require('../components/PopUp.scss.js');
require('../../../styles/index.scss.js');
require('../../../../node_modules/react-responsive-modal/styles.css.js');
var Button = require('../../Button/Button.js');
var index = require('../../../../node_modules/classnames/index.js');
require('../../ButtonGroup/ButtonGroup.scss.js');
require('../../Badge/Badge.scss.js');
require('../../Label/Label.scss.js');
require('../../Checkbox/Checkbox.scss.js');
require('../../Icon/Icon.scss.js');
require('../../Button/helper.scss.js');
require('../../Switch/Switch.scss.js');
var Radio = require('../../Radio/Radio.js');
var RadioGroup = require('../../RadioGroup/RadioGroup.js');
var Input = require('../../Input/Input.js');
require('../../Loader/Loader.scss.js');
require('../../Footer/Footer.scss.js');
require('../../Navbar/Navbar.js');
require('../../Navbar/MobileNavigation/styles.scss.js');
require('../../../../node_modules/pure-react-carousel/dist/index.es.js');
require('../../Carousel/Carousel.scss.js');
require('../../../../node_modules/pure-react-carousel/dist/react-carousel.es.css.js');
require('../../Pagination/Pagination.scss.js');
require('../../Modal/Modal.scss.js');
require('../../DropDown/DropDown.scss.js');
require('../../Accordion/AccordionGroup.js');
require('../../Accordion/AccordionIcon.scss.js');
require('../../Accordion/Accordion.scss.js');
require('../../Stepper/Stepper.scss.js');
require('../../Tabs/Tabs.scss.js');
require('../../BottomNavigation/FooterNavigation/Tools/Tools.scss.js');
require('../../BottomNavigation/FooterNavigation/Insurance/Insurance.scss.js');
require('../../BottomNavigation/FooterNavigation/Account/Account.scss.js');
require('../../BottomNavigation/FooterNavigation/Explore/Explore.scss.js');
require('../../BottomNavigation/FooterNavigation/FooterNavigation.scss.js');
require('../../../utils/hooks/canUseWebp.js');
require('../../BottomNavigation/BottomNavigation.scss.js');
require('../../ViewMore/ViewMore.scss.js');
require('../../Login/Login.js');
require('../index.js');
require('../../Swiper/index.js');
require('../../Alert/Alert.scss.js');
require('../../Loader/LifepalLoader.js');
require('../../SEOAccordion/SEOAccordion.scss.js');
require('../../Skeleton/index.js');
require('../../LifepalProvider/LifepalProvider.js');
require('react-dom');
require('../../../../node_modules/react-responsive-modal/node_modules/classnames/index.js');
require('../../../../node_modules/body-scroll-lock/lib/bodyScrollLock.esm.js');
require('../../ResponsiveModal/style.scss.js');
require('../../Card/Card.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var KYCForm = function (props) {
    var className = props.className, back = props.back, onBackButtonClick = props.onBackButtonClick, backIcon = props.backIcon, title = props.title, errorMessage = props.errorMessage, onValueChange = props.onValueChange, isSubmitting = props.isSubmitting, singleError = props.singleError, onSubmit = props.onSubmit, buttonKYCText = props.buttonKYCText;
    var _a = React.useState(''), type = _a[0], setType = _a[1];
    var _b = React.useState(''), ktp = _b[0], setKTP = _b[1];
    var _c = React.useState(''), passport = _c[0], setPassport = _c[1];
    var _d = React.useState(''), annualIncome = _d[0], setAnnualIncome = _d[1];
    var _f = React.useState(''), sourceOfFund = _f[0], setSourceOfFund = _f[1];
    var handleChangeType = function (thisType) {
        setType(thisType);
        setKTP('');
        setPassport('');
    };
    return (React__default['default'].createElement(React__default['default'].Fragment, null,
        title !== false && React__default['default'].createElement(Header.Header, { className: className && className['header'], back: back, onBackButtonClick: onBackButtonClick, backIcon: backIcon, title: title }),
        React__default['default'].createElement("div", { className: "login__forms-accounts " + ((className && className['root']) || className) },
            React__default['default'].createElement("div", { className: "login__forms-accounts-inputs__radio-type " + (errorMessage && errorMessage.gender && 'normal') },
                React__default['default'].createElement("h2", { className: 'login__forms-accounts-title' }, "Verifikasi ID"),
                React__default['default'].createElement(RadioGroup.RadioGroup, { id: 'select-gender', groupAlignment: 'horizontal' },
                    React__default['default'].createElement(Radio.Radio, { id: 'type', name: 'type', labelName: 'KTP', value: 'KTP', isChecked: type === 'KTP' ? true : false, handleOnChange: function (_e, name, value) {
                            handleChangeType(value);
                            if (onValueChange) {
                                onValueChange();
                            }
                        } }),
                    React__default['default'].createElement(Radio.Radio, { id: 'type', name: 'type', labelName: 'Passport', value: 'Passport', isChecked: type === 'Passport' ? true : false, handleOnChange: function (_e, name, value) {
                            handleChangeType(value);
                            if (onValueChange) {
                                onValueChange();
                            }
                        } }))),
            errorMessage && errorMessage.type &&
                React__default['default'].createElement("p", { className: 'login__forms-accounts-inputs__labels__errors' }, errorMessage.type),
            React__default['default'].createElement(Input.Input, { id: type === 'KTP' ? '' : '', name: type === 'KTP' ? '' : '', type: "numeric", inputMode: 'numeric', value: type === 'KTP' ? ktp : passport, size: 'lg', maxLength: 16, placeholder: type === 'KTP' ? 'No. KTP' : 'No. Passport', onChange: function (e) {
                    if (type === 'KTP') {
                        setKTP(e.target.value);
                    }
                    else {
                        setPassport(e.target.value);
                    }
                    if (onValueChange) {
                        onValueChange();
                    }
                }, className: index['default']('login__forms-accounts-inputs__fields', {
                    'login__forms-accounts-inputs__fields-error': errorMessage && ((type === 'KTP' && !errorMessage.ktp) || (type === 'Passport' && !errorMessage.passport)),
                    'login__forms-accounts-inputs__fields__errors': errorMessage && ((errorMessage.ktp || errorMessage.passport) || (singleError && Object.keys(errorMessage).length > 0)),
                }), disabled: isSubmitting }),
            errorMessage && !errorMessage.type && (errorMessage.ktp || errorMessage.passport) &&
                React__default['default'].createElement("p", { className: 'login__forms-accounts-inputs__labels__errors' }, (errorMessage.ktp || errorMessage.passport)),
            React__default['default'].createElement(Input.Input, { id: 'annualIncome', name: 'annualIncome', type: 'numeric', value: annualIncome, size: 'lg', placeholder: 'Pendapatan Dalam Setahun', onChange: function (e) {
                    setAnnualIncome(e.target.value);
                    if (onValueChange) {
                        onValueChange();
                    }
                }, inputMode: 'numeric', isCurrency: true, className: index['default']('numeric login__forms-accounts-inputs__fields', {
                    'login__forms-accounts-inputs__fields-error': errorMessage && !errorMessage.annualIncome,
                    'login__forms-accounts-inputs__fields__errors': errorMessage && (errorMessage.annualIncome || (singleError && Object.keys(errorMessage).length > 0)),
                }), disabled: isSubmitting }),
            errorMessage && errorMessage.annualIncome &&
                React__default['default'].createElement("p", { className: 'login__forms-accounts-inputs__labels__errors' }, errorMessage.annualIncome),
            React__default['default'].createElement(Input.Input, { id: 'sourceOfFund', name: 'sourceOfFund', type: 'text', inputMode: 'text', value: sourceOfFund, size: 'lg', placeholder: 'Sumber Pendapatan', onChange: function (e) {
                    setSourceOfFund(e.target.value);
                    if (onValueChange) {
                        onValueChange();
                    }
                }, className: index['default']('login__forms-accounts-inputs__fields', {
                    'login__forms-accounts-inputs__fields__errors': errorMessage && (errorMessage.sourceOfFund || (singleError && Object.keys(errorMessage).length > 0)),
                    'login__forms-accounts-inputs__fields-error': errorMessage && !errorMessage.sourceOfFund,
                }), disabled: isSubmitting }),
            errorMessage && errorMessage.sourceOfFund &&
                React__default['default'].createElement("p", { className: 'login__forms-accounts-inputs__labels__errors' }, errorMessage.sourceOfFund),
            React__default['default'].createElement(Button.Button, { variant: 'primary', id: 'regis-btn', type: 'submit', disabled: isSubmitting, className: 'action-button bottom-16p', onClick: function () {
                    onSubmit({
                        type: type,
                        ktp: ktp,
                        passport: passport,
                        annualIncome: annualIncome,
                        sourceOfFund: sourceOfFund,
                    });
                } }, buttonKYCText || 'Simpan'))));
};

exports.KYCForm = KYCForm;
//# sourceMappingURL=KYCForm.js.map
